module.exports = __webpack_public_path__ + "static/media/logo3.1f672761.png";